export default {
  state: {
    mainNavShowStatus: false,
    webNavigator: '',
    ZMLApp:false,
  },
  actions: {
    getSwiper ({}, callback) {
      if (window.Swiper) {
        callback && callback();
      } else {
        let swiperScript = document.createElement('script');
        swiperScript.setAttribute('src', 'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/node_modules/Swiper4.4.6/dist/js/swiper.min.js');
        swiperScript.onload = swiperScript.onreadystatechange = function () {
          if (swiperScript.ready) return false;
          if (!swiperScript.readyState || swiperScript.readyState == 'loaded' || swiperScript.readyState == 'complete') {
            callback && callback();
            swiperScript.onload = swiperScript.onreadystatechange = null;
            swiperScript.ready = true;
          }
        };
        document.getElementsByTagName('body')[0].appendChild(swiperScript);
      }
    },
    getProviceCityArea ({}, callback) {
      if (window.proviceCityArea) {
        callback && callback();
      } else {
        let swiperScript = document.createElement('script');
        // swiperScript.setAttribute('src', 'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/node_modules/proviceCity/_threeCity.js');
        swiperScript.setAttribute('src', 'https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/node_modules/proviceCity/threeCity.js');
        swiperScript.onload = swiperScript.onreadystatechange = function () {
          if (swiperScript.ready) return false;
          if (!swiperScript.readyState || swiperScript.readyState == 'loaded' || swiperScript.readyState == 'complete') {
            callback && callback();
            swiperScript.onload = swiperScript.onreadystatechange = null;
            swiperScript.ready = true;
          }
        };
        document.getElementsByTagName('body')[0].appendChild(swiperScript);
      }
    },
  },
  mutations: {
    // navigatorReg (state) {
    //   if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
    //     state.webNavigator = 'phone';
    //   } else if (document.body.clientWidth <= 800) {
    //     state.webNavigator = 'phone';
    //   } else {
    //     state.webNavigator = 'pc';
    //   }
    //   // console.log(state.webNavigator, '当前使用样式1');
    // },
    changeNavigator (state, type) {
      state.webNavigator = type;
      // console.log(state.webNavigator, '当前使用样式2');
    },
    changeMainNavShowStatus (state) {
      state.mainNavShowStatus = !state.mainNavShowStatus;
    },
  },
};



// WEBPACK FOOTER //
// src/store/common/common.js